import { useState } from "react";
import { Tabs } from "antd";
import {FileTextOutlined} from "@ant-design/icons";
import PersonalInfo from "./PersonalInfo";
import ChangePassword from "./ChangePassword";
import InvoiceList from "./InvoiceList";

const UserInfoContent = () => {
  const [tabActiveKey, setTabActiveKey] = useState("1");

  const items = [
    {
      key: "1",
      label: (
        <span>
          <i className=" pr-1 fs-18 las la-user-tie"></i>Personal Info
        </span>
      ),
      children: <PersonalInfo />,
    },
    {
      key: "2",
      label: (
        <span>
          <i className=" pr-1 fs-18 las la-user-lock"></i>Change Password
        </span>
      ),
      children: <ChangePassword />,
    },
    {
      key: "3",
      label: (
        <span>
          <FileTextOutlined className="pr-1" />Invoices
        </span>
      ),
      children: <InvoiceList />,
    },
  ];

  const onChange = (key) => {
    setTabActiveKey(key);
  };

  return <Tabs activeKey={tabActiveKey} items={items} onChange={onChange} />;
};

export default UserInfoContent;
